import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import QRCodeReact from 'qrcode.react'

// import searchPointActions from './searchpointactions';
import BookResource from './resource'
import BookText from './text'

import Diagnostic from './diagnostic'
import Coordinates from './coordinates'
import { ChapterLink, ChapterLinkScenario } from './link'
import * as api from '../../../lib/api'
import checks from '../../../lib/check'

// Repris à l'identique de la page de validation des parcours (checks.js)
const METHODS = {
  code: { label: 'Mot code', color: '#5bc0de' },
  qrcode: { label: 'QR Code', color: '#337ab7' },
  image: { label: 'Image', color: '#9b59b6' }
}
const TRIGGERS = {
  manual: { label: 'Au clic sur le point', color: '#777' },
  location: { label: "Par la position de l'utilisateur", color: '#5cb85c' },
  beacon: { label: 'Balise bluetooth', color: '#0275d8' }
}

export default class extends Component {
  state = {}
  async componentDidMount() {
    const { point, score, nonDiagnostic } = this.props
    const checkPoint = !nonDiagnostic && (await checks.checkPoint(point))

    // Comme checks.js : pré-charge la ressource de la cible image
    const check = point.check
    if (check && check.type === 'image' && check.target) {
      const targetId = typeof check.target === 'string' ? check.target : check.target.resource
      const overlayId = typeof check.target === 'string' ? null : check.target.overlay
      if (targetId) {
        check.targetResource = await api.resources.get(targetId).catch(() => null)
      }
      if (overlayId) {
        check.overlayResource = await api.resources.get(overlayId).catch(() => null)
      }
    }

    if (score && checkPoint && checkPoint.warnings && score < 50) {
      checkPoint.warnings.push({
        text: 'score trop faible',
        _id: point._id
      })
    }
    if (score && checkPoint && checkPoint.warnings && score > 200) {
      checkPoint.warnings.push({
        text: 'score trop élevé',
        _id: point._id
      })
    }
    this.setState({ checkPoint })
  }

  renderCheckContent(check) {
    const type = check.type

    if (type === 'code') {
      return (
        <div className="check-visual">
          <div className="check-field-label">Code à saisir</div>
          <div className="check-code">{check.code || <span className="check-missing">non défini</span>}</div>
        </div>
      )
    }

    if (type === 'qrcode') {
      return (
        <div className="check-visual">
          {check.code ? (
            <>
              <QRCodeReact style={{ padding: '8px' }} value={check.code} size={150} level="M" />
              <div className="check-qrcode">{check.code}</div>
            </>
          ) : (
            <span className="check-missing">aucun code défini</span>
          )}
        </div>
      )
    }

    if (type === 'image') {
      const target = check.target || {}
      const targetName = typeof target === 'object' ? target.name : null
      const { targetResource, overlayResource } = check
      return (
        <div className="check-visual">
          {targetResource ? (
            <img
              className="check-image"
              src={api.resources.getUrl(targetResource.hd?.file || targetResource.original?.file)}
              alt={targetName || ''}
            />
          ) : (
            <span className="check-missing">image cible manquante</span>
          )}
          {targetName && (
            <div style={{ marginTop: '8px' }}>
              <div className="check-field-label">Cible Vuforia</div>
              <div className="check-code">{targetName}</div>
            </div>
          )}
          {overlayResource && (
            <div style={{ marginTop: '8px' }}>
              <div className="check-field-label">Image de remplacement</div>
              <img
                className="check-image overlay"
                src={api.resources.getUrl(overlayResource.hd?.file || overlayResource.original?.file)}
                alt=""
              />
            </div>
          )}
        </div>
      )
    }

    return null
  }

  renderTriggerDetail(trigger) {
    if (trigger.type === 'location' && trigger.distance != null) {
      return <span className="trigger-detail">{trigger.distance} m</span>
    }
    if (trigger.type === 'beacon' && (trigger.uuid || trigger.macAdress)) {
      return <span className="trigger-detail">{trigger.uuid || trigger.macAdress}</span>
    }
    return null
  }

  render() {
    const { point, chapters, _id, url, usedBy, nonDiagnostic, highlights, children } = this.props
    const checkPoint = this.state.checkPoint
    let {
      name,
      internalName,
      scenario: scenarioId,
      check,
      active,
      visible,
      triggers,
      picture,
      timeLimit,
      points,
      bonus,
      notes
    } = point
    check = check || {}
    const validTriggers = (triggers || []).filter(t => t && t.type)
    const locationHighlighed = highlights && highlights.location
    let actions
    return (
      <article className="point" id={_id}>
        <h2>
          {name && (
            <BookText
              id={_id}
              collection="points"
              path="name"
              text={name}
              highlights={highlights}
              style={{ display: 'inline-block' }}
            />
          )}
          {!name && (
            <BookText
              id={_id}
              collection="points"
              path="internalName"
              text={internalName}
              highlights={highlights}
              style={{ display: 'inline-block' }}
            />
          )}
          <Link to={url}>
            <i className="fa fa-edit" />
          </Link>
        </h2>
        <section>
          <aside className="common">
            {(timeLimit > 0 || points > 0 || bonus > 0) && (
              <div className="aside-metrics">
                {timeLimit > 0 && (
                  <span className="aside-metric">
                    <i className="fa fa-clock-o" /> {timeLimit} s
                  </span>
                )}
                {(points > 0 || bonus > 0) && (
                  <span className="aside-metric">
                    <i className="fa fa-trophy" /> {(points || 0) + (bonus || 0)} pts
                  </span>
                )}
              </div>
            )}
            <div className="aside-statuses">
              <span
                className={'aside-status ' + (active ? 'on' : 'off')}
                title={`Ce point est ${active ? 'actif' : 'inactif'} au début du jeu`}
              >
                <i className="fa fa-power-off" /> {active ? 'Actif' : 'Inactif'}
              </span>
              <span
                className={'aside-status ' + (visible ? 'on' : 'off')}
                title={`Ce point est ${visible ? 'visible' : 'invisible'} au début du jeu`}
              >
                <i className="fa fa-eye" /> {visible ? 'Visible' : 'Masqué'}
              </span>
            </div>
            {Object.keys(point.markers || {}).some(key => point.markers[key] && point.markers[key].resource) && (
              <div className="aside-media-group">
                <div className="field-label">Marqueurs</div>
                <div className="aside-media-row">
                  {Object.keys(point.markers || {}).map(key => {
                    const marker = point.markers[key]
                    if (!marker.resource) {
                      return null
                    }
                    return (
                      <BookResource
                        id={marker.resource}
                        style={{ maxWidth: '72px' }}
                        title={key}
                        key={key}
                        path={'markers°|°' + key}
                        highlights={highlights}
                      />
                    )
                  })}
                </div>
              </div>
            )}
            {Object.keys(point.icons || {}).some(key => point.icons[key]) && (
              <div className="aside-media-group">
                <div className="field-label">Icônes</div>
                <div className="aside-media-row">
                  {Object.keys(point.icons || {}).map(key => {
                    const icon = point.icons[key]
                    if (!icon) {
                      return null
                    }
                    return (
                      <BookResource
                        id={icon}
                        style={{ maxWidth: '72px' }}
                        title={key}
                        key={key}
                        path={'icons°|°' + key}
                        highlights={highlights}
                      />
                    )
                  })}
                </div>
              </div>
            )}
          </aside>
          <div>
            {bonus > 0 && (
              <span>
                {' '}
                <i className="fa fa-2x fa-trophy" />
                Dont {bonus} pts bonus si l'utilisateur n'a pas besoin de la bousolle
                <br />
              </span>
            )}

            <div className="book-map">
              <Coordinates
                zoom={18}
                loadingElement={<div style={{ height: '100%' }} />}
                containerElement={<div style={{ height: '400px', width: '100%', margin: '0 auto' }} />}
                mapElement={<div style={{ height: '100%' }} className={locationHighlighed ? 'highlighted' : ''} />}
                points={[point]}
              />
            </div>
            <BookResource id={picture} style={{ maxWidth: '100%' }} path="picture" highlights={highlights} />
            {actions && actions.length > 0 && (
              <div>
                Ces actions modifient l'état de ce point :
                <ul>
                  {actions.map(({ chapter, action }, index) => {
                    return chapter.type === 'scenario' ? (
                      <li key={index}>
                        <ChapterLinkScenario
                          chapters={chapters}
                          scenarioId={chapter._id}
                          text={`${action.type} dans le chapitre`}
                        />
                      </li>
                    ) : (
                      <li key={index}>
                        <ChapterLink
                          key={index}
                          chapter={chapter.chapter}
                          scene={chapter.scene}
                          text={`${action.type} dans le chapitre`}
                        />
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}
            <div className="point-check-card">
              <div className="check-section">
                {check.type && METHODS[check.type] ? (
                  <>
                    <div className="check-section-header">
                      <div className="check-section-title">Validation</div>
                      <span className="method-badge" style={{ backgroundColor: METHODS[check.type].color }}>
                        {METHODS[check.type].label}
                      </span>
                    </div>
                    {this.renderCheckContent(check)}
                  </>
                ) : (
                  <span className="check-muted">Aucune méthode de validation</span>
                )}
              </div>
              {validTriggers.length > 0 && (
                <div className="check-section">
                  <div className="check-section-title">Déclenchement sans validation</div>
                  <div className="trigger-badges">
                    {validTriggers.map((trigger, i) => {
                      const meta = TRIGGERS[trigger.type] || { label: trigger.type, color: '#999' }
                      return (
                        <div className="trigger-badge" key={i}>
                          <span className="trigger-dot" style={{ backgroundColor: meta.color }} />
                          <span>{meta.label}</span>
                          {this.renderTriggerDetail(trigger)}
                        </div>
                      )
                    })}
                  </div>
                </div>
              )}
            </div>
            {check.clue && (
              <p>
                Indices : <ChapterLinkScenario chapters={chapters} scenarioId={check.clue} />
              </p>
            )}
            {check.scenario && (
              <p>
                Scénario lancé après validation : <ChapterLinkScenario chapters={chapters} scenarioId={check.scenario} />
              </p>
            )}
            {scenarioId && (
              <p>
                Scénario du point : <ChapterLinkScenario chapters={chapters} scenarioId={scenarioId} />
              </p>
            )}
          </div>
          {!nonDiagnostic && <Diagnostic checks={checkPoint} usedBy={usedBy} notes={notes} chapters={chapters} />}
        </section>
        <section>
          <div>{children}</div>
        </section>
      </article>
    )
  }
}
